// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
const initialState = {
  PlanbatchById:{},
  PlanbatchLIst:[],
  PlanbatchPage:1,
  PlanbatchSize:10,
  PlanbatchTotal:0,
  getPlanbatchListActionPending: false,
  getPlanbatchListActionError: null,
  plan_lngList:[],
  plan_lngPage:1,
  plan_lngSize:10,
  plan_lngTotal:0,
  plan_lngById:{},
  plan_lngModalType:"create",
  plan_lngModalVisible:false,
  currentPlan_lng:{},
  getPlan_lngListPending: false,
  getPlan_lngListError: null,
  submitPlan_lngPending: false,
  submitPlan_lngError: null,
  deletePlan_lngPending: false,
  deletePlan_lngError: null,
  certificateCompilesId:'',
  certificateCompileModalVisible:false,
  certificateCompileActionsPending: false,
  certificateCompileActionsError: null,
  qualityProveModalvisible:false,
  qualityProveCompileActionsPending: false,
  qualityProveCompileActionsError: null,
  qualityProvesId:'',
  mediumSafetyUploadingActionsPending: false,
  mediumSafetyUploadingActionsError: null,
  mediumSafetyUploadingVisible:false,
  mediumSafetyUploadingId:'',
  qpDataFileUploadingVisible:false,
  qpDataFileUploadingId:'',
  getAllbatchActionsPending: false,
  getAllbatchActionsError: null,
  getAllBatch:{},
  getCheckActionsPending: false,
  getCheckActionsError: null,
  getGenerateActionsPending: false,
  getGenerateActionsError: null,
  getAllQpxlListPending: false,
  getAllQpxlListError: null,
  getAllQpxlListId:{},
  getAllQpxlListList:[],
  currentQpxh:'',
  getAllMakeJjdwActionsPending: false,
  getAllMakeJjdwActionsError: null,
  getAllMakeJjdwList:[],
  getAllMakeJjdwId:{},
  qpDataFileUploadingActionPending: false,
  qpDataFileUploadingActionError: null,
  buildqpdataFileActionPending: false,
  buildqpdataFileActionError: null,
  qpParamsFileUploadingVisible:false,
  qpParamsFileUploadingId: undefined,
  qpParamsFileUploadingActionPending: false,
  qpParamsFileUploadingActionError: null
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/plan/redux/initialState.js